import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.network.dns.zone.bulkUpdateTTL;

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice,
	actionType: 'NETWORK_DNS_ZONE_BULKUPDATETTL',
	method: 'POST',
	url: '/network/dns/zone/bulkUpdateTTL.json',
});

export { actions, reducer, sagas, selectors };
